"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
// Relements
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var ProgressBar_1 = __importDefault(require("@src/components/ProgressBar"));
var const_1 = require("./const");
var InProgressModal = function (_a) {
    var active = _a.active, onClose = _a.onClose, fetchActions = _a.fetchActions, startTime = _a.startTime;
    var _b = react_1["default"].useState(0), loaderPercent = _b[0], setLoaderPercent = _b[1];
    var _c = react_1["default"].useState(false), modalActive = _c[0], setModalActive = _c[1];
    var elapsedSeconds = react_1["default"].useMemo(function () { return (startTime ? Math.floor(Date.now() / 1000 - startTime) : null); }, [startTime]);
    react_1["default"].useEffect(function () {
        var percent = (elapsedSeconds / 2) * 5;
        setLoaderPercent(percent < 100 ? percent : 100);
    }, [elapsedSeconds]);
    react_1["default"].useEffect(function () {
        var intervalId;
        if (active) {
            intervalId = setInterval(function () {
                setLoaderPercent(function (prev) {
                    if (prev >= 100) {
                        clearInterval(intervalId);
                        return 100;
                    }
                    return prev + 5 > 100 ? 100 : prev + 5;
                });
            }, 2000);
        }
        else if (loaderPercent > 0 && loaderPercent < 100) {
            setLoaderPercent(100);
        }
        else
            setLoaderPercent(0);
        return function () {
            if (intervalId)
                clearInterval(intervalId);
        };
    }, [active]);
    react_1["default"].useEffect(function () {
        if (loaderPercent === 100 && !active) {
            fetchActions(true);
            var timeoutId_1 = setTimeout(function () {
                setModalActive(false);
                onClose();
            }, 1000);
            return function () { return clearTimeout(timeoutId_1); };
        }
        setModalActive(active || (loaderPercent !== 0 && loaderPercent < 100));
    }, [active, loaderPercent]);
    return (react_1["default"].createElement(modal_1["default"], { themed: true, active: modalActive, onClose: modalActive ? function () { } : onClose, hideCloseIcon: true, maxHeight: "800px", padding: "0px", footerBorder: false },
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", width: "75vw", padding: "2px 8px 0px 8px", style: { maxWidth: '844px' } },
            react_1["default"].createElement("img", { src: const_1.AI_CODE_NODE_BANNER_URL }),
            react_1["default"].createElement(box_1["default"], { flexDirection: "column", alignItems: "center", padding: "100px 20px", justifyContent: "center" },
                react_1["default"].createElement(ProgressBar_1["default"], { percent: loaderPercent, showLoaderAfterComplete: true }),
                react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "0", mt: "24px", width: "60%", alignItems: "center" },
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Generating your action\u2026"),
                    react_1["default"].createElement(text_1["default"], { variant: "body.md", textAlign: "center", style: { marginTop: '16px' } }, "We\u2019re setting up the action definition, parameters, and logic. This usually takes a couple of minutes"))))));
};
exports["default"] = InProgressModal;
InProgressModal.propTypes = {
    active: prop_types_1["default"].bool.isRequired,
    onClose: prop_types_1["default"].func.isRequired,
};
